import { useState } from 'react'
import {
  Paper,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useTranslation } from 'react-i18next'
import LayoutContent from '@/components/LayoutContent'
import Channels from './components/channels'
import Camera from './components/camera'

const tabs = [
  {
    id: 'channels',
    translateKey: 'channels',
  },
  {
    id: 'cameras',
    translateKey: 'cameras',
  },
];
const componentByTabId = {
  channels: <Channels />,
  cameras: <Camera />,
}
const DevicesPage = () => {
  const { t } = useTranslation();
  const [activeTabId, setActiveTabId] = useState('channels');
  return (
    <LayoutContent>
      <Paper
        elevation={8}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          // maxHeight: theme.constants.widgetMaxHeight,
          p: 2,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>{t('devices')}</Typography>
        <SelectorTabs
          tabs={tabs}
          value={activeTabId}
          onChange={(e, val) => setActiveTabId(val)}
        />
        { componentByTabId[activeTabId] }
      </Paper>
    </LayoutContent>
  )
}

const SelectorTabs = ({
  tabs,
  value,
  onChange
}) => {
  const { t } = useTranslation();
  return (
    <Tabs
      value={value}
      onChange={onChange}
      // variant="scrollable"
      scrollButtons="auto"
      sx={{
        mb: 2
      }}
    > 
      {
        tabs.map((tab) => (
          <Tab 
            value={tab.id}
            label={t(tab.translateKey)}
            key={tab.id}
          />
        ))
      }
    </Tabs>
  )
}

export default DevicesPage;